import { useState } from "react";
import { HTTP_STATUSES, QUALIFICATION_TYPES } from "@miplatform/constants";
import { buildSearchQuery, createUUID } from "@miplatform/utils";
import { useComponentState } from "../useComponentState/useComponentState";

const getQualificationUUID = createUUID();

export const useResourceGroup = ({ service }) => {
  const [resourceGroups, setResourceGroups] = useState([]);
  const stateManager = useComponentState();

  const getResourceGroups = (search = "") => {
    stateManager.run(async () => {
      const searchQuery = buildSearchQuery(search, ["name"]);
      const response = await service.qualifications.getAll({
        filters: {
          type: QUALIFICATION_TYPES.RESOURCE_GROUP,
          ...searchQuery,
        },
        sort: "name asc",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setResourceGroups(response?.data);
      }
    }, getQualificationUUID);
  };

  return {
    getResourceGroups,
    resourceGroups,
    loading: stateManager.isBusy(),
  };
};
